// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';

export const GenericPlusGlyph = (props: ComponentProps<'svg'>) => (
	<svg
		{...props}
		width="24px"
		height="24px"
		viewBox="7.5 0.5 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_10645_15679)">
			<rect width="16" height="16" transform="translate(8 8)" fill="white" fillOpacity="0.01" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.0619 8H9.994C8.895 8 8 8.893 8 9.994V22.006C8.00026 22.5348 8.21043 23.0418 8.58432 23.4157C8.95821 23.7896 9.46524 23.9997 9.994 24H22.006C22.5348 23.9997 23.0418 23.7896 23.4157 23.4157C23.7896 23.0418 23.9997 22.5348 24 22.006V14.9381C20.3813 14.4869 17.5131 11.6187 17.0619 8ZM13.333 11H16H16.782C16.9614 10.9998 17.139 11.0359 17.3041 11.106C17.4692 11.1761 17.6185 11.2788 17.743 11.408L19.907 13.658C19.9667 13.7201 20 13.8029 20 13.889V14.792C20 14.975 19.851 15.125 19.667 15.125H17.333C16.597 15.125 16 14.528 16 13.792V12.378H13.333V19.622H18.667V16H20V19.622C20 20.383 19.403 21 18.667 21H13.333C12.597 21 12 20.382 12 19.622V12.378C12 11.617 12.597 11 13.333 11Z"
				fill="#5E6C84"
			/>
		</g>
		<rect x="19" y="1" width="12" height="12" rx="6" fill="#22A06B" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z"
			fill="white"
		/>
		<defs>
			<clipPath id="clip0_10645_15679">
				<rect width="16" height="16" fill="white" transform="translate(8 8)" />
			</clipPath>
		</defs>
	</svg>
);
